import polyglotI18nProvider from 'ra-i18n-polyglot';
import en from './en';
import ch from './ch';

const translations: any = { en, ch };

export const i18nProvider = polyglotI18nProvider(
    locale => translations[locale],
    'ch',
    [{ locale: 'en', name: 'English' }, { locale: 'ch', name: '简体中文' }],
);